import { getStore } from "../../../api/services/storeService.js";
import { getTrackingOrder, getOrderHistory } from "../../../api/services/orderService.js";
import { getOrderStatus } from "../../../api/helpers/orderHelper";
import { interpolate } from "../../../api/helpers/stringHelper";
import { mapMutations, mapActions, mapGetters } from "vuex";
import { DateTime } from "luxon";
import { logger } from "../../../api/Logger";
export default {
  methods: {
    ...mapMutations(["setStoreLoaded", "setDeliveryAddress"]),
    ...mapActions(["insertErrorlog", "redirectToErrorPage", "loadFromStorage"]),
    beforeDestroyComponent() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
    },
    createdComponent() {
      var that = this;
      getStore(this.selectedCompanyId ? this.selectedCompanyId : this.storeid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            that.store = doc.data();
          }
        })
        .catch((reason) => {
          that.insertErrorlog([
            reason.name,
            reason.toString(),
            that.$router.currentRoute.fullPath,
          ]);
          that.redirectToErrorPage();
        });
      //get order
      if (this.userid) {
        getTrackingOrder(
          this.userid,
          this.orderid,
          this.selectedCompanyId ? this.selectedCompanyId : this.storeid
        ).onSnapshot(
          (doc) => {
            if (doc.exists) {
              that.trackingOrder = doc.data();
              that.updateDisplayModel(that.trackingOrder);
            } else {
              getOrderHistory(
                this.userid,
                this.orderid,
                this.selectedCompanyId ? this.selectedCompanyId : this.storeid
              ).onSnapshot(
                (doc) => {
                  if (doc.exists) {
                    that.trackingOrder = doc.data();
                    that.updateDisplayModel(that.trackingOrder);
                  } else {
                    that.trackingOrder = null;
                  }
                },
                function(reason) {
                  that.insertErrorlog([
                    reason.name,
                    reason.toString(),
                    that.$router.currentRoute.fullPath,
                  ]);
                  that.redirectToErrorPage();
                }
              );
            }
          },
          function(reason) {
            that.insertErrorlog([
              reason.name,
              reason.toString(),
              that.$router.currentRoute.fullPath,
            ]);
            that.redirectToErrorPage();
          }
        );
      }
    },
    continueShopping() {
      this.$router.push({
        name: "store",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    viewHistory() {
      this.$router.push({
        name: "orderhistory",
        params: {
          storeid: this.$route.params.storeid,
          storename: this.$route.params.storename,
        },
      });
    },
    backToCheckout() {
      this.loadFromStorage();
      if (this.trackingOrder.DeliveryAddress) {
        var address = {
          StreetAddress: this.trackingOrder.DeliveryAddress.Address,
          PostalCode: this.trackingOrder.DeliveryAddress.Postcode,
          CityTown: this.trackingOrder.DeliveryAddress.Suburb,
          State: this.trackingOrder.DeliveryAddress.State,
        };
        this.setDeliveryAddress(address);
      }
      if (this.cartItems.length == 0) {
        this.$router.push({
          name: "checkout",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
            orderid: this.trackingOrder.UDID,
          },
        });
      } else {
        if (this.displayModel.status < 0) {
          if (this.displayModel.status === -2) {
            logger.log(
              "Action Retry Payment in Finalize",
              "Retry Payment Button is pressed",
              "/CompleteOrder",
              logger.LogType.Info
            );
          } else {
            logger.log(
              "Action Retry in Finalize",
              "Retry Button is pressed",
              "/CompleteOrder",
              logger.LogType.Info
            );
          }
        }

        this.$router.push({
          name: this.displayModel.status == -2 ? "checkout" : "store",
          params: {
            storeid: this.$route.params.storeid,
            storename: this.$route.params.storename,
          },
        });
      }
    },
    updateDisplayModel(order) {
      this.displayModel.OrderType = order.OrderType;
      if (order.OrderType === 10 || order.OrderType === 2) {
        this.displayModel.orderMode = "message.checkoutDelivery";
      } else {
        this.displayModel.orderMode = "message.pickUp";
      }
      //update status
      this.displayModel.status = getOrderStatus(order);

      switch (this.displayModel.status) {
        case -3:
          if (this.isOrderFailed)
            this.displayModel.orderState = this.$t("message.orderFaild");
          else this.displayModel.orderState = this.$t("message.orderRejected");
          break;
        case -2:
          this.displayModel.orderState = this.$t("message.paymentFaild");
          break;
        case -1:
          this.displayModel.orderState = this.$t("message.orderRejected");
          break;
        case 0:
          this.displayModel.orderState = this.$t("message.orderSent");
          break;
        case 3:
          this.displayModel.orderState = this.$t("message.orderSubmitted");
          break;
        case 1:
          this.displayModel.orderState = this.$t("message.beingPrepared");
          break;
        case 2:
          if (order.OrderType === 10 || order.OrderType === 2)
            this.displayModel.orderState = this.$t("message.onItsWay");
          else this.displayModel.orderState = this.$t("message.readyForPickup");
          break;
        case 4:
          this.displayModel.orderState = this.$t("message.orderCompleted");
          break;
        case 5:
          this.displayModel.orderState = this.$t("message.orderRefunded");
          break;
        case 6:
          this.displayModel.orderState = this.$t("message.orderCancelRequest");
          break;
      }

      if (order.OnlineOrderStatus >= 18 && order.OnlineOrderStatus <= 20) {
        this.displayModel.isPayLater = true;
      } else {
        this.displayModel.isPayLater = false;
      }
    },
    updateStatus(statusDesc) {
      this.displayModel.orderState = statusDesc;
    },
    formatDate(date) {
      if (date) {
        var jsDate = new Date(date.seconds * 1000);
        var cDate = DateTime.fromJSDate(jsDate);
        return cDate.toFormat("dd MMMM yyyy h:mm a");
      } else {
        return "";
      }
    },
  },
  computed: {
    ...mapGetters(["cartItems", "checkLocalCartItemsExists"]),
    isTwoColumn() {
      return this.store.IsDisableStatusTracking ||
      (this.trackingOrder.OnlineOrderStatus >= 18 &&
        this.trackingOrder.OnlineOrderStatus <= 20);
    },
    estimatedPickupDeliveryTimeLabel() {
      return interpolate(
        this.$t("message.estimatedPickupDeliveryTime"),
        this.$t(this.displayModel.orderMode)
      );
    },
    isOrderFailed() {
      if (
        this.trackingOrder.OnlineOrderStatusDescription &&
        this.trackingOrder.OnlineOrderStatusDescription.indexOf(
          "We’re having problems reaching the store"
        ) > -1
      ) {
        return true;
      }
      return false;
    },
    isDineIn() {
      return this.displayModel.OrderType == 8
        || this.displayModel.OrderType == 2;
    },
  },
};
